
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import SelectionView from '../../../../../components/selectionView/SelectionView'
import Info from '../../misc/Info'
import OpenItem from '../../misc/OpenItem'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var constants = require('../../../../../utils/domain/constants.js');
var translator = require('../../../../../utils/translator/translator');
var stringUtil = require('../../../../../utils/string/stringUtil');
var saleContextUtil = require('../../../utils/saleContextUtil.js');
var saleInitializer = require('../../../../../utils/domain/sales/saleInitializer');
var logger = require('../../../../../utils/logger/logger');

class TableToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);

        this.renderMenuSelections = this.renderMenuSelections.bind(this);
        this.renderDispatchTypeDialogue = this.renderDispatchTypeDialogue.bind(this);
        this.renderOpenItemDialogue = this.renderOpenItemDialogue.bind(this);

        this.state = {};
        this.state.showMenuSelectionDialogue = false;
        this.state.showDispatchTypeDialogue = false;
        this.state.showOpenItemDialogue = false;
        this.state.showInfoDialogue = false;
    }

    render()
    {
        return (<Fragment>
                    <div style={{textAlign:'center',color:"#787878"}}
                             onClick={(event) =>
                             {
                                event.stopPropagation();

                                this.state.showMenuSelectionDialogue = true;
                                this.setState({});
                             }}>
                            <MenuBarIcon size="2.3vw"/>
                    </div>
                    {this.renderMenuSelections()}
                    {this.renderDispatchTypeDialogue()}
                    {this.renderOpenItemDialogue()}
                    {this.renderInfoDialogue()}
                </Fragment>)
    }

    renderMenuSelections()
    {
        if (!this.state.showMenuSelectionDialogue)
            return null;

        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        let selections = [];

        let selection = {};
        selection.caption = translator.getLabel("change_dispatch_type");
        selection.id = "1";
        selection.isDisabled = !saleCommonUtility.canChangeDispatchType(saleContext);
        selections.push(selection);

        if (!saleCommonUtility.canHoldUnHoldSale(saleContext))
        {
            selection = {};
            selection.caption = translator.getLabel("hold_sale");
            selection.id = "2";
            selection.isDisabled = true;
            selections.push(selection);
        }
        else
        {
            if (!saleCommonUtility.isSaleHoldByStaff(sale))
            {
                selection = {};
                selection.caption = translator.getLabel("hold_sale");
                selection.id = "2";
                selection.isDisabled = false;
                selections.push(selection);
            }
            else
            {
                selection = {};
                selection.caption = translator.getLabel("unhold_sale");
                selection.id = "2";
                selection.isDisabled = false;
                selections.push(selection);
            }   
        }

        selection = {};
        selection.caption = translator.getLabel("open_items");
        selection.id = "3";
        selection.isDisabled = !saleCommonUtility.canHaveOpenItems(saleContext);
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("get_info");
        selection.id = "4";
        selection.isDisabled = false;
        selections.push(selection);

        return <SelectionView selections={selections} caption={translator.getLabel("options")}
                                onClose={()=>
                                {
                                    this.state.showMenuSelectionDialogue = false;
                                    this.setState({});
                                }}
                                onSelection={(selection)=>
                                {
                                    this.state.showMenuSelectionDialogue = false;
                                    this.setState({});
                                    
                                    if (selection.id == "1")
                                    {
                                        this.state.showDispatchTypeDialogue = true;
                                        this.setState({});
                                    }

                                    if (selection.id == "2")
                                    {
                                        if (stringUtil.areStringSame(sale.saleType, constants.SaleTypeSale))
                                        {
                                            sale.saleType = constants.SaleTypeHold;
                                            sale.holdReasonCode = constants.holdReasonCode.staff;
                                            sale.driverId = null;
                                            sale.discounts = [];
                                            sale.charges = [];
                                        }
                                        else
                                        {
                                            sale.saleType = constants.SaleTypeSale;
                                            sale.holdReasonCode = null;
                                        }

                                        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                                    }

                                    if (selection.id == "3")
                                    {
                                        logger.usage("Options.OpenItem", "Staff clicked to add an open item");
                                        this.state.showOpenItemDialogue = true;
                                        this.setState({});
                                    }

                                    if (selection.id == "4")
                                    {
                                        this.state.showInfoDialogue = true;
                                        this.setState({});
                                    }
                                }}/>
    }

    renderDispatchTypeDialogue()
    {
        if (!this.state.showDispatchTypeDialogue)
            return null;

        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        let selections = [];

        let selection = {};
        selection.caption = translator.getLabel("dineIn")
        selection.id = constants.DispatchTypeDineIn;;
        selection.isSelected = sale.dispatchType == selection.id;
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("collection")
        selection.id = constants.DispatchTypeCollection;;
        selection.isSelected = sale.dispatchType == selection.id;
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("takeAway")
        selection.id = constants.DispatchTypeTakeAway;
        selection.isSelected = sale.dispatchType == selection.id;
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("delivery")
        selection.id = constants.DispatchTypeDelivery;
        selection.isSelected = sale.dispatchType == selection.id;
        selections.push(selection);

        return <SelectionView selections={selections} caption={translator.getLabel("dispatch_types")}
                                onClose={()=>
                                {
                                    this.state.showDispatchTypeDialogue = false;
                                    this.setState({});
                                }}
                                onSelection={(selection)=>
                                {
                                    this.state.showDispatchTypeDialogue = false;
                                    this.setState({});

                                    this.changeDispatchType(sale, selection.id);
                                }}/>
    }

    renderInfoDialogue()
    {
        if (!this.state.showInfoDialogue)
            return null;

        return <Info sale={this.props.saleContext.sale} onClose={()=>
                                {
                                    this.state.showInfoDialogue = false;
                                    this.setState({})
                                }}/>
    }

    renderOpenItemDialogue()
    {
        if (!this.state.showOpenItemDialogue)
            return null;

        return <OpenItem 
                    onCancel={()=>
                    {
                        this.state.showOpenItemDialogue = false;
                        this.setState({});                
                    }}
                    handleSubmit={(openItem)=>
                    {
                        this.state.showOpenItemDialogue = false;
                        this.setState({});   

                        let vat = saleInitializer.calculateUnitTax(openItem.unitPrice * 1, (openItem.vat * 1) / 100);
                        let saleItem = saleInitializer.createSaleItem("Open Items", openItem.quantity * 1, openItem.caption, openItem.unitPrice * 1, vat);
                        saleItem.instructions = openItem.instructions;
                        this.props.saleContext.sale.saleItems.push(saleItem);
                        saleContextUtil.setSaleItemMenuContext(saleItem, openItem, true);
                        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                    }}/>
    }

    changeDispatchType(sale, newDispatchType)
    {
        if (sale.dispatchType == newDispatchType)
            return;

        if (!stringUtil.isStringNullOrEmpty(sale.dispatchInfo))
        {
            let dispatchInfo = JSON.parse(sale.dispatchInfo);
            dispatchInfo.dispatchType = newDispatchType;
            sale.dispatchInfo = JSON.stringify(dispatchInfo);
        }

        if (sale.dispatchType == constants.DispatchTypeDineIn)
        {
            var originalSaleNumber = sale.number.split("/");
            if (originalSaleNumber.length == 2)
                originalSaleNumber = stringUtil.trimString(originalSaleNumber[1]);
            else
                originalSaleNumber = stringUtil.trimString(originalSaleNumber[0]);

            sale.number = originalSaleNumber;
            sale.tableNumber = null;
            sale.linkedTables = [];
            sale.server = null;
            sale.noOfGuests = null;
        }

        if (sale.dispatchType == constants.DispatchTypeTakeAway)
        {
            var originalSaleNumber = sale.number.split("/");
            if (originalSaleNumber.length == 2)
                originalSaleNumber = stringUtil.trimString(originalSaleNumber[1]);
            else
                originalSaleNumber = stringUtil.trimString(originalSaleNumber[0]);
            sale.number = originalSaleNumber;
        }

        if (sale.dispatchType == constants.DispatchTypeDelivery)
        {
            if (!stringUtil.isStringNullOrEmpty(sale.dispatchInfo))
            {
                let dispatchInfo = JSON.parse(sale.dispatchInfo);
                delete dispatchInfo.deliveryAddress;
                delete dispatchInfo.distance;
                sale.dispatchInfo = JSON.stringify(dispatchInfo);
            }
        }

        sale.discounts = [];
        sale.charges = [];
        sale.dispatchType = newDispatchType;
        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(TableToolbarButton)

const MenuBarIcon = ({size}) => {
    return (
        <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></path>
</svg>
    )
}